module.exports = __webpack_public_path__ + "static/img/sox0.ee6c860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/furnitures/sox0.png
// module id = diRb
// module chunks = 0